import { h } from 'preact';
import { VertexPreview } from '../../types/graph';
import { VertexPreviewCard } from '../VertexPreviewCard';

export interface VertexCardProps {
  url: string;
  preview?: VertexPreview;
}

export function VertexCard({ url, preview }: VertexCardProps) {
  return (
    <div class="graph-current-vertex">
      <VertexPreviewCard url={url} preview={preview} />
    </div>
  );
}
